<template>
  <div>
    <slot name="default"></slot>
  </div>
</template>

<script>
export default {
  name: 'ErrorBoundary',

  errorCaptured(error, vm) {
    this.$buefy.notification.open({
      duration: 3000,
      message: error.message,
      type: 'is-danger',
    })
    this.$errorProcessor.addTracingInfo({
      message: 'ErrorBoundary',
      data: vm,
    })
    this.$errorProcessor.capture(`From ErrorBoundary: ${error}: stack: ${error.stack}`, {
      errorLocation: this.$route.path,
    })
    return false
  },
}
</script>
